exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".MemberInfo_MemberInfo_39DSf {\n    border-bottom: 1px dotted dimgray;\n    border-top: 1px dotted dimgray;\n    padding: 10px;\n    display: flex;\n    flex-flow: row;\n    background-color: snow;\n}", ""]);

// Exports
exports.locals = {
	"MemberInfo": "MemberInfo_MemberInfo_39DSf"
};